import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { FormattedMessage, useIntl } from 'react-intl';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaCalendar } from 'react-icons/fa';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import messages from '../registrationMessages';
const RecurrencePreviewPart = ({ userId, date, recurrence, durationDays, isAfternoon, fromMinutes, toMinutes, resourceType, onLoaded, }) => {
    const intl = useIntl();
    const [days, setDays] = useState(null);
    const { intervalWeeks, endDate } = recurrence;
    useEffect(() => {
        let requestToken = null;
        const timeoutHandler = setTimeout(() => {
            requestToken = Axios.CancelToken.source();
            api.base
                .post(`${config.appUrls.api}/api/Registration/CalcDurationInDays`, {
                userId,
                date,
                durationDays,
                isAfternoon,
                fromMinutes,
                toMinutes,
                resourceType,
                recurrence: { intervalWeeks, endDate },
            }, { cancelToken: requestToken.token })
                .then(({ data }) => {
                setDays(data);
                onLoaded(data);
            })
                .catch(error => {
                if (!Axios.isCancel(error)) {
                    handleHttpError(intl)(error);
                }
            });
        }, 500);
        return () => {
            clearTimeout(timeoutHandler);
            if (requestToken)
                requestToken.cancel('Operation canceled due to new request.');
        };
    }, [
        userId,
        date,
        durationDays,
        isAfternoon,
        fromMinutes,
        toMinutes,
        resourceType,
        intervalWeeks,
        endDate,
        intl,
        onLoaded,
    ]);
    if (!days)
        return null;
    const totalMinutes = days.reduce((total, day) => total + day.durationMinutes, 0);
    return (_jsxs("div", Object.assign({ className: "form-control-static" }, { children: [_jsx(FormattedMessage, Object.assign({}, messages.RecurringAbsencesCount, { values: { count: days.length } })), days.length > 0 && (_jsxs(_Fragment, { children: ["\u00A0(", totalMinutes.minuteToTime(), ")\u00A0", _jsx(OverlayTrigger, Object.assign({ trigger: ['hover', 'focus'], placement: "right", rootClose: true, overlay: _jsx(Tooltip, Object.assign({ id: "recurrencePreviewTooltip" }, { children: _jsx("table", { children: _jsx("tbody", { children: days.map(day => (_jsxs("tr", { children: [_jsxs("td", Object.assign({ className: "text-right text-nowrap" }, { children: [intl.formatDate(day.date, {
                                                        weekday: 'short',
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                    }), "\u00A0\u00A0\u00A0"] })), _jsx("td", Object.assign({ className: "text-right text-nowrap" }, { children: day.durationMinutes.minuteToTime() }))] }, day.date))) }) }) })) }, { children: _jsx("span", Object.assign({ className: "clickable" }, { children: _jsx(FaCalendar, { className: "react-icon" }) })) }))] }))] })));
};
export default RecurrencePreviewPart;
